import { Row, Column, Caption } from 'gatsby-theme-carbon/src/components/Grid';
import { withPrefix } from "gatsby";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import img1 from "../../../../src/visuals/design/content_5_1_eg.png";
import img2 from "../../../../src/visuals/design/content_5_2_eg.png";
import img3 from "../../../../src/visuals/design/content_5_3_eg.png";
import "../../../../src/pages/toolkit/topics.scss";
import * as React from 'react';
export default {
  Row,
  Column,
  Caption,
  withPrefix,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  img1,
  img2,
  img3,
  React
};